import {
  FUNDS_AND_PORTFOLIOS_PATH,
  MANAGE_ACCESS_PATH,
  SCREEN_COMPANIES_PATH,
  SCREEN_FUND_HOLDINGS_PATH,
  SCREEN_FUNDS_PATH,
} from '@upright/ui/common/generic/components/navigation/page-paths';
import { FACADE_URL } from '@upright/ui/ui-constants';
import { getRedirectRoute } from '../route-utils';
import { RedirectDatum } from '../types';

const redirects: RedirectDatum[] = [
  { from: 'funds', to: '/?tab=funds', type: 'external' },
  { from: 'companies', to: '/for-companies/', type: 'internal' },
  { from: 'investors', to: `${FACADE_URL}/products/investors/`, type: 'external' },
  { from: 'terms-of-use', to: `${FACADE_URL}/terms-of-use`, type: 'external' },
  { from: 'privacy-policy', to: `${FACADE_URL}/privacy-policy`, type: 'external' },
  { from: 'lander', to: '/main/', type: 'internal' },
  { from: 'mapper-search', to: '/mapper/search', type: 'internal' },
  { from: 'mapper-sidebar', to: '/mapper/sidebar', type: 'internal' },
  {
    from: 'products/csrd-double-materiality-assessment',
    to: `${FACADE_URL}/products/csrd-double-materiality-assessment/`,
    type: 'external',
  },
  {
    from: 'csrd-double-materiality-assessment-for-asset-managers',
    to: `${FACADE_URL}/products/csrd-double-materiality-assessment-for-asset-managers`,
    type: 'external',
  },
  { from: 'asset-managers', to: `${FACADE_URL}/products/investors/`, type: 'external' },
  { from: 'asset-owners', to: `${FACADE_URL}/products/asset-owners/`, type: 'external' },
  { from: 'private-equity', to: `${FACADE_URL}/products/private-equity/`, type: 'external' },
  { from: 'data-platforms', to: `${FACADE_URL}/products/data-platforms/`, type: 'external' },
  { from: 'datasets/', to: `${FACADE_URL}/products/datasets/`, type: 'external' },
  {
    from: 'csrd-double-materiality-assessment-product/',
    to: `${FACADE_URL}/products/csrd-double-materiality-assessment/`,
    type: 'external',
  },
  { from: 'un-sdg-revenue-alignment/', to: `${FACADE_URL}/products/un-sdg-revenue-alignment/`, type: 'external' },
  { from: 'for-companies/', to: `${FACADE_URL}/products/companies/`, type: 'external' },
  { from: 'for-investors/', to: `${FACADE_URL}/products/investors/`, type: 'external' },
  {
    from: 'csrd-double-materiality-assessment/',
    to: `${FACADE_URL}/products/csrd-double-materiality-assessment/`,
    type: 'external',
  },
  // PLT-6931: investor pages renamed to what they are labelled. Kept for bookmarks, shared links,
  // chat history, and the blog posts and release notes that link into the screeners with their
  // filters in the query string. React Router ranks the longer `from`s above `browse` itself.
  { from: 'investor-home', to: FUNDS_AND_PORTFOLIOS_PATH, type: 'moved' },
  { from: 'my-assets', to: MANAGE_ACCESS_PATH, type: 'moved' },
  { from: 'browse/funds', to: SCREEN_FUNDS_PATH, type: 'moved' },
  { from: 'browse/fund-holdings', to: SCREEN_FUND_HOLDINGS_PATH, type: 'moved' },
  { from: 'browse', to: SCREEN_COMPANIES_PATH, type: 'moved' },
];

export function getRedirectRoutes() {
  return redirects.map(getRedirectRoute);
}
